import React from "react";

export const ProjectPicker = ({ projects, projectId, setProjectId }) => {
    const isConfigured = projectId !== "inbox";

    return (
        <div className="max-w-[190px] w-full relative">
            <select
                value={projectId}
                onChange={(e) => setProjectId(e.target.value)}
                className={`w-full px-2.5 py-1.5 border rounded-lg text-xs focus:outline-none transition-all duration-200 ${
                    isConfigured
                        ? "bg-indigo-50 border-indigo-300 text-indigo-800 font-semibold shadow-sm"
                        : "bg-slate-50 border-gray-200 text-gray-600 font-medium"
                }`}
            >
                <option value="inbox">📥 Bandeja de Entrada</option>
                {projects.map((proj) => (
                    <option key={proj.id} value={proj.id}>
                        {proj.icon} {proj.name}
                    </option>
                ))}
            </select>
        </div>
    );
};
